module.exports = __webpack_public_path__ + "img/tarot.86de2c2a.png";